import React from 'react';
import { AppStateUser, useAppState } from '../../../client/providers/AppProvider';
import { ConversationContainer } from './ConversationContainer';
import { InboxContainer } from './InboxContainer';
import { gql } from '@urql/core';
import { useMessagesContext } from '../../../pages/dashboard/messages';
import { InitialMessageContent } from './InitialConversationContent';
import { MessagesCardFragment } from '../../../generated/spin-graphql';
import { useRouter } from 'next/router';

type Props = {
    className?: string;
    user: AppStateUser;
    initialMessageContent?: InitialMessageContent;
    asyncMessageSearch: (searchTerm: string) => Promise<any>;
    adminMessages: MessagesCardFragment[];
};

gql`
    fragment MessagesCard on espin_message {
        ...InboxContainer
        ...ConversationContainer
    }
`;

export const MessagesCard: React.FC<Props> = ({
    className,
    user,
    initialMessageContent,
    asyncMessageSearch,
    adminMessages,
}) => {
    const { subscribed } = useAppState();
    const router = useRouter();
    const {
        messagesDispatch,
        messagesState: { filteredConversationList, selectedIndex, searchTermString },
    } = useMessagesContext();
    return (
        <div className={`messages-card${className ? ` ${className}` : ''}`}>
            <InboxContainer
                user={user}
                initialMessageContent={initialMessageContent}
                asyncMessageSearch={asyncMessageSearch}
                adminMessages={adminMessages}
            />
            <ConversationContainer
                user={user}
                selectedConversation={!subscribed ? undefined : filteredConversationList[selectedIndex]}
                onBackClicked={() => {
                    messagesDispatch({ type: 'setSelectedIndex', index: undefined });
                    router.query.back_to_inbox = 'true';
                    router.query.show_admin_messages = 'false';
                }}
                initialMessageContent={initialMessageContent}
                searchActive={searchTermString !== ''}
                adminMessages={adminMessages}
            />
        </div>
    );
};
